module.exports = {
    LIST: 'LIST',
    MAP: 'MAP',
    DASHBOARD: 'DASHBOARD',
    NITRATES_CODE: '1340',
    SUM_PESTICIDES_LABO: '6276',

    CATCHMENT_PESTICIDES: 'CATCHMENT_PESTICIDES',
    CATCHMENT_IRRELEVANT_PESTICIDES: 'CATCHMENT_IRRELEVANT_PESTICIDES',
    CATCHMENT_LIST_SUM_PESTICIDES: 'CATCHMENT_LIST_SUM_PESTICIDES',

    AVERAGE_SUBSTANCE: 'AVERAGE_SUBSTANCE',
    MAX_SUBSTANCE: 'MAX_SUBSTANCE',
    AVERAGE_SUM: 'AVERAGE_SUM',
    MAX_SUM: 'MAX_SUM',

    MISSING_DATA: 'missingData',
    NITRATES_PESTICIDES: 'nitratesAndPesticides',
    NITRATES: 'nitrates',
    PESTICIDES: 'pesticides',
    NO_CONTAMINATION: 'noContaminationHigherThanThreshold',

    LAST_VALUE: 0,
    MIN: 1,
    MAX: 2,
    AVERAGE: 3,
    P90: 4,

    DEFAULT_OBJECTIVE: 80,

    DEFAULT_THRESHOLD_NITRATES: 50,
    DEFAULT_THRESHOLD_PESTICIDES_1: 0.1,
    DEFAULT_THRESHOLD_PESTICIDES_2: 0.5,
    DEFAULT_THRESHOLD_IRRELEVANT_PESTICIDES: 0.9,
    DEFAULT_REGROUPMENT: 2,
}